import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { pxToRem } from 'common/utils/fonts.ts';
import { UploadDialog } from '@/activityLog/bulkProvisioning/Components/UploadDialog.tsx';
import { ImportError, UploadSnackbar } from '@/activityLog/common/Upload/UploadSnackbar.tsx';
import { useTranslation } from 'react-i18next';

type UploadButtonProps = {
  importError: ImportError | null;
  isPending: boolean;
  selectedFile: File | null;
  inputId: string;
  inputDataTestId?: string;
  buttonDataTestId?: string;

  onSelectFile: (file: File | null) => void;
  onConfirm: () => void;
  onCancel: () => void;
  onCloseSnackbar: () => void;
};

export const UploadButton = ({
  inputId,
  inputDataTestId,
  buttonDataTestId,
  onSelectFile,
  onConfirm,
  isPending,
  onCancel,
  onCloseSnackbar,
  importError,
  selectedFile,
}: UploadButtonProps) => {
  const { t } = useTranslation();
  return (
    <Box>
      <label htmlFor={inputId}>
        <Input
          id={inputId}
          data-testid={inputDataTestId}
          type="file"
          sx={{ display: 'none' }}
          onChange={(event) => {
            const fileInput = event.target as HTMLInputElement;
            if (fileInput?.files?.[0]) {
              onSelectFile(fileInput.files[0]);
              // file input cannot be controlled. This is hack to reset the input field that allow upload the same
              // file in row
              event.target.value = '';
            }
          }}
        />
        <Button
          data-testid={buttonDataTestId}
          variant="contained"
          component="span"
          disabled={isPending}
          startIcon={<AddIcon sx={{ width: pxToRem(16), height: pxToRem(16) }} />}
          sx={{ py: 8, pl: 16, pr: 26, whiteSpace: 'nowrap' }}
        >
          {t('common.uploadFile')}
        </Button>
      </label>
      <UploadDialog
        open={!!selectedFile && !importError}
        fileName={selectedFile?.name || ''}
        onConfirm={() => {
          if (isPending || importError) {
            return;
          }

          onConfirm();
        }}
        onCancel={onCancel}
      />

      <UploadSnackbar importError={importError} onClose={onCloseSnackbar} />
    </Box>
  );
};
